/**
 * Botaniche — Scroll Reveal
 * Intersection Observer API for scroll-triggered animations
 * Lightweight, zero-dependency
 */
(function() {
  'use strict';

  function initScrollReveal() {
    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.querySelectorAll('.scroll-reveal').forEach(function(el) {
        el.classList.add('scroll-reveal--visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal--visible');
            observer.unobserve(entry.target);

            // Trigger number counter if present
            const counter = entry.target.querySelector('[data-count]');
            if (counter && !counter._counted) {
              counter._counted = true;
              animateCounter(counter);
            }
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    document.querySelectorAll('.scroll-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  // Animated number counter
  function animateCounter(el) {
    const text = el.textContent;
    const match = text.match(/[\d,.]+/);
    if (!match) return;

    const targetStr = match[0].replace(/,/g, '');
    const target = parseFloat(targetStr);
    if (isNaN(target)) return;

    const suffix = text.includes('★') ? '★' : text.includes('+') ? '+' : '';
    const duration = 2000;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease-out quad
      const eased = 1 - (1 - progress) * (1 - progress);
      const current = Math.round(target * eased);

      if (target >= 1000) {
        el.textContent = current.toLocaleString() + '+' + suffix;
      } else if (target === Math.floor(target)) {
        el.textContent = current + suffix;
      } else {
        el.textContent = (target * eased).toFixed(1) + suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
})();
